import {HorizontalBar, mixins} from 'vue-chartjs'

export default {
  extends: HorizontalBar,
  mixins: [mixins.reactiveProp],
  props: ['chartData', 'options'],
  data: function () {
    return {
      htmlLegend: null
    }
  },
  methods: {
    setChart: function () {
      this.renderChart(this.chartData, {
        ...this.options,
        legend: {
          display: false
        }
      })
      this.htmlLegend = this.generateLegend()
      this.$emit('setLegend', this.htmlLegend)
    }
  },
  watch: {
    chartData: function () {
      this.$data._chart.destroy()
      this.setChart()
    }
  },
  mounted () {
    this.setChart()
  }
}



// WEBPACK FOOTER //
// ./src/util/HorizontalBarChart.js